<template>
  <ankh-list :show-search-form="false">
    <template #btn-group>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #table="{height}">

      <table-list
          ref="list"
          :height="height"
          row-key="id"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          :indent="16"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" :label="$t('序号')" width="50" fixed />
        <el-table-column prop="userNum" :label="$t('用户ID')" fixed />
        <el-table-column prop="username" :label="$t('用户昵称')" fixed />
        <el-table-column prop="content" :label="$t('意见内容')"/>
        <el-table-column prop="phone" :label="$t('联系方式')"/>
        <el-table-column prop="photo" :label="$t('图片')">
          <template v-slot="{row}">
            <preview-img :img-url="row.photo" :size="60" :length="3" />
          </template>
        </el-table-column>
        <el-table-column prop="createTimeStr" :label="$t('时间')" />
        <el-table-column prop="reply" :label="$t('回复内容')">
          <template v-slot="{row}">
            <span v-if="row.reply">{{ row.reply }}</span>
            <el-link v-else :underline="false" type="primary" @click="$router.push('edit?code=' + row.code)">{{$t('未回复：立即回复')}}</el-link>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" min-width="30">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="$router.push('edit?code=' + row.code)">{{$t('查看')}}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "SuggestList",
  components: {AnkhList, PreviewImg, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
    }
  },
  methods: {
    async handleDelete(row) {
      try {
        await requestByTip(this.$api.suggestion.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if(!codes.length) {
          this.$message.warning(this.$t('请选择要删除的数据'));
          return;
        }
        await requestByTip(
            this.$api.suggestion.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();

      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.suggestion.list, params);
        this.tableData = res.suggestions.map(item => {
          item.createTimeStr = this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
          const photoList = item.photo ? item.photo.split(",") : [];
          item.photoList = photoList.map(i => this.$api.file.downloadImg + i);
          return item;
        })

        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

</style>
